import React, { Component } from "react";
import {
  pendenciasAtrasadasTMK,
  ListaVendedoresAtivos,
  runVerificaAutenticacao,
  ListaTelasCRM,
} from "../../../services/api";
import "../../../sass/app.scss";
import GridTable from "../../../lib/GridTable";
import $ from "jquery";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Header from "../../../components/Header";
import {
  ButtonFilter,
  ContentFilter,
  ContentFilterSelectVendedor,
  ContentLoading,
  ContentLoadingContent,
  ContentTables,
  ContentTablesHighlights,
  ContentTablesItem,
  ContentTablesName,
  PendenciasAtrasadasTMKContainer,
  SelectBox,
  PendenciasAtrasadasTMKContainerText
} from "./styles";
import { Box, Image } from "@chakra-ui/react";

const loading = "/images/loading-verde.gif";

class PendenciasAtrasadasTMK extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
      dadosTotal: [],
      vendedores: [],
      usuario_selecionado: null,
      view_loading: false,
      codigo_usuario: JSON.parse(localStorage.getItem("authentication"))
        .codigo_usuario,
      codigo_vendedor: JSON.parse(localStorage.getItem("authentication"))
        .codigo_vendedor,

      control_inclusao: null,
      control_alteracao: null,
      control_exclusao: null,
      control_consulta: null,
    };
  }

  componentDidMount() {
    runVerificaAutenticacao();
    this.initial();
  }

  initial = async () => {
    await this.CarregaPermissoes();

    if ([0, 30, 22, 21, 14, 12].includes(this.state.codigo_usuario)) {
      this.getConfig();
    } else {
      this.getVendedores();
      this.getLessons();
    }
  };

  CarregaPermissoes = async () => {
    try {
      const response = await ListaTelasCRM.get(
        "/" + window.location.pathname.replace("/", "")
      );
      var data = response.data;

      var codigo_tela = null;
      for (var obj in data) {
        codigo_tela = obj;
      }

      this.setState({
        codigo_tela: codigo_tela,
        control_inclusao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].inclusao,
        control_alteracao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].alteracao,
        control_exclusao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].exclusao,
        control_consulta: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].consulta,
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };
  getConfig = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    
    const vendedor = queryParams.get("v");

    await this.getVendedores();

    if (vendedor != null) {
      $("#selectVendedor").val(vendedor);
      await this.setState({ usuario_selecionado: vendedor });
    }
    
    this.getLessons();
  };
  
  getVendedores = async () => {
    try {
      const response = await ListaVendedoresAtivos.get();
      var data = response.data;
      
      var vendedores = [];
      data.map((data) => {
        vendedores.push({
          value: data.codigo_usuario,
          label: data.nome_vendedor,
        });
      });
      
      this.setState({ vendedores: vendedores });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };
  
  getLessons = async () => {
    this.setState({ dados: [], dadosTotal: [], view_loading: true });
    if (this.state.control_consulta != "S") {
      alert("Permissão negada");
      return false;
    }

    const user =
    this.state.usuario_selecionado != null
        ? this.state.usuario_selecionado
        : this.state.codigo_usuario;
        
        try {
          this.setState({ view_loading: true });
          const response = await pendenciasAtrasadasTMK.get("/" + user);
          
          const dados = response.data.splice(0, response.data.length - 1);
          const dadosTotal = response.data.splice(-1, 1);
          
          await this.setState({
            dados: dados,
            dadosTotal: dadosTotal,
        view_loading: false,
      });
    } catch (error) {
      this.setState({ view_loading: false });
      console.log(Object.keys(error), error.message);
    }
  };
  
  selectUsuario = async (e) => {
    var option = e.target.options[e.target.options.selectedIndex].value;
    await this.setState({ usuario_selecionado: option });
  };
  render() {
    const { dados, dadosTotal, vendedores } = this.state;
    
    const columns = [
      {
        dataField: "numero_nota",
        text: "Número único TMK",
        css: { width: "65px" },
        sort: true,
      },
      {
        dataField: "numero_pedido",
        text: "Proposta",
      },
      {
        dataField: "nome_cliente",
        text: "Nome cliente",
        sort: true,
      },
      {
        dataField: "codigo_parceiro",
        text: "Codigo parceiro",
        sort: true,
      },
      {
        dataField: "nome_contato",
        text: "Contato",
        sort: true,
      },
      {
        dataField: "numero_telefone",
        text: "Número telefone",
        css: { width: "90px" },
        sort: true,
      },
      {
        dataField: "email",
        text: "E-mail",
        sort: true,
      },
      {
        dataField: "data_chamado",
        text: "Chamado",
        sort: true,
      },
      {
        dataField: "data_agendamento",
        text: "Agendamento",
        sort: true,
      },

      {
        dataField: "descricao_historico",
        text: "Descrição histórico",
        sort: true,
      },
      {
        dataField: "data_ultima_alteracao",
        text: "Ultima alteração",
        sort: true,
      },
      {
        dataField: "",
        text: "Abrir proposta",
        element: (
          <a href={``}>
            <span className="icon icon-20 icon-folder-pink"></span>
          </a>
        ),
      },
    ];

    return (
      <>
        <PendenciasAtrasadasTMKContainer>
          <PendenciasAtrasadasTMKContainerText>
            <h1>
              PENDÊNCIAS <strong>ATRASADAS</strong> TMK
            </h1>
          </PendenciasAtrasadasTMKContainerText>

          <Box>
            <ContentLoading
              style={
                this.state.view_loading
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <ContentLoadingContent>
                <Image alt="loading" src={loading} />
              </ContentLoadingContent>
            </ContentLoading>
            {[0, 30, 22, 21, 14, 12].includes(this.state.codigo_usuario) ? (
              <ContentFilter>
                <ContentFilterSelectVendedor>
                  <SelectBox
                    bgColor="white"
                    color="gray.500"
                    iconColor="#e7404b"
                    fontSize="20px"
                    variant="outline"
                    focusBorderColor="#e7404b"
                    _hover={{ borderBottomColor: "#e7404b" }}
                    _active={{ borderBottomColor: "#e7404b" }}
                    placeholder="Vendedores..."
                    id={"selectVendedor"}
                    onChange={(e) => this.selectUsuario(e)}
                  >
                    {vendedores.map((data) => {
                      return <option value={data.value}>{data.label}</option>;
                    })}
                  </SelectBox>
                </ContentFilterSelectVendedor>
                <ButtonFilter onClick={() => this.getLessons()}>
                  Aplicar
                </ButtonFilter>
              </ContentFilter>
            ) : (
              <></>
            )}

            <ContentTables>
              <ContentTablesHighlights>
                {dadosTotal.map((dado) => (
                  <>
                    <ContentTablesItem>
                      <ContentTablesName>
                        TOTAL DE PENDÊNCIAS ATRASADAS TMK:{" "}
                        <strong> {dado.codigo_proposta}</strong>
                      </ContentTablesName>
                    </ContentTablesItem>
                  </>
                ))}
              </ContentTablesHighlights>

              {dados.length > 0 ? (
                <GridTable columns={columns} dados={dados} />
              ) : (
                <></>
              )}
            </ContentTables>
          </Box>
        </PendenciasAtrasadasTMKContainer>
      </>
    );
  }
}

export default PendenciasAtrasadasTMK;
